import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import BriefingEvent from "../event/BriefingEvent";

export default class BriefingCommand extends AbstractCommand {
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {TextContent} */
        this._content = data.content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = data.contentPlayer;

        this._handleCloseBound = this._handleClose.bind(this);
        this._dispatcher.addEventListener(BriefingEvent.CLOSE_REQUEST, this._handleCloseBound);

        this._screenSkin = this.openScreen(SkinKeyRegistry.BRIEFING_SCREEN_SKIN, {}, {
            content: this._content,
        });
    }

    _handleClose() {
        this._dispatcher.removeEventListener(BriefingEvent.CLOSE_REQUEST, this._handleCloseBound);

        this.closeScreen(this._screenSkin);

        this._contentPlayer.contentCompleted(this._content);
    }
}